(function($, $window, $document) {
  'use strict';

	var $requestEventForm   = $('.request_event_form'),
		submitting          = false,
		$monthsSelects      = $requestEventForm.find('select.month_select'),
		$yearsSelects       = $requestEventForm.find('select.year_select'),
		$mapLocationHolder	= $requestEventForm.find('#map_location_holder');

	$requestEventForm.on('submit', function (e) {
		e.preventDefault();

		$requestEventForm.validate();
	})

	$requestEventForm.validate({
		rules: {
			first_name: {
				required: true
			},
			last_name: {
				required: true
			},
			email: {
				required: true
			},
			phone: {
				required: true
			},
			city: {
				required: true
			},
			zip: {
				required: true
			},
			state: {
				required: true
			},
			title: {
				required: true
			},
			description: {
				required: true
			},
		},
		submitHandler: function(form) {
			submitEventRequest(form);
		}
	});

	function submitEventRequest(form) {
		if (submitting) {
			return;
		}

		submitting = true;

		var data = {
			formdata: transformFormData($(form).serializeArray()),
			action: 'request_event',
			security: ajax_object.ajax_nonce
		}

		$.ajax({
			type : "post",
			dataType : "json",
			url : ajax_object.ajax_url,
			data : data,
			success: function(response) {
				submitting = false

				if (response.status == 'error') {
					showFormErrors(response.errors)
				} else {
					$requestEventForm.find('.form_section').hide();
					$requestEventForm.find('.link_holder').hide();
					$requestEventForm.find('.form_section.section_success').show();
				}
			},
			error: function () {
				submitting = false
			}
		})
	}

	function showFormErrors(errors) {
		Object.keys(errors).forEach(function (key) {
			$requestEventForm.find('[name="' + key+'"]').after('<label id="' + key + '-error" class="error" for="' + key + '">' + errors[key] +'</label>');
		})

		if (errors['start_date']) {
			$requestEventForm.find('.left_date').append('<label id="start_date-error" class="error" for="start_date">' + errors['start_date'] +'</label>')
		}

		if (errors['end_date']) {
			$requestEventForm.find('.right_date').append('<label id="end_date-error" class="error" for="end_date">' + errors['end_date'] +'</label>')
		}

		if (errors['location']) {
			$mapLocationHolder.append('<label id="location-error" class="error">' + errors['location'] +'</label>')
		}

		scrollToHeighestErrorLabel();
	}

	function scrollToHeighestErrorLabel() {
		var heighestError = undefined;
		
		$requestEventForm.find('label.error').each(function () {
			if (heighestError == undefined || heighestError >= $(this).offset().top) {
				heighestError = $(this).offset().top
			}
		});

		if (heighestError != undefined) {
			$('html, body').animate({
				scrollTop: heighestError - 300
			}, 600);
		}
	}

	function transformFormData(formData) {
		var data = {};

		formData.forEach(function (item) {
			data[item.name] = item.value;
		})

		return data;
	}

	$monthsSelects.on('change', function () {
		var $daysSelect = $requestEventForm.find('#' + $(this).attr('data-days-select')),
			$yearsSelect = $requestEventForm.find('#' + $(this).attr('data-year-select'));

		setDaysSelect($daysSelect, this.value, $yearsSelect.val());
	});

	$yearsSelects.on('change', function () {
		var $daysSelect = $requestEventForm.find('#' + $(this).attr('data-days-select')),
			$monthsSelect = $requestEventForm.find('#' + $(this).attr('data-month-select'));

		setDaysSelect($daysSelect, $monthsSelect.val(), this.value);
	});

	function setDaysSelect(select, month, year) {
		if (Boolean(Number(month)) && Boolean(Number(year))) {
			var selectedDay = $(select).val();

			var days = daysInMonth(month, year);

			var html = '<option value="0">Day</option>';

			if (typeof days == 'number' && !isNaN(days)) {
				html += createRangeArray(days).map(function (dayNr) {
					return '<option value="' + (dayNr + 1) + '">' + (dayNr + 1) + '</option>';
				}).join('');
			}

			$(select).html(html).val(selectedDay ? selectedDay : 0);
		}
	}

	function daysInMonth(month, year) {
		return new Date(year, month, 0).getDate();
	}

	function createRangeArray(nr) {
		return Array.apply(null, {length: nr}).map(Number.call, Number)
	}
})(window.jQuery, window, document);
